<template>
      <div class="page page-inner">
        <breadcrumb title="Request to Use Compensation Day"></breadcrumb>
        <div class="card card-fluid">
          <div class="card-header nav-scroller">
            <!-- .nav-tabs -->
            <ul class="nav nav-tabs card-header-tabs">
              <li class="nav-item">
                <a href="#" class="nav-link active" @click.prevent="setActive('compensatory-request')" data-toggle="tab" >Compensatory Request</a>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link" @click.prevent="setActive('compensatory-approval')" data-toggle="tab" >Subordinate</a>
              </li>
            </ul>
            <!-- /.nav-tabs -->
          </div>
          <!-- .card-body -->
          <div class="card-body">
            <div class="tab-content py-3" >
              <div class="tab-pane fade" :class="{ 'active show': isActive('compensatory-request') }">
                <div id="data-table-leave-request-request_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                      <div class="dt-buttons btn-group">
                        <button class="btn btn-success btn-modal" v-b-modal.modal-request tabindex="0"  data-title="Request" v-show="action_button.add">
                          <em class="fa fa-plus"></em> <span>Request</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div id="data-table-leave-request-request_filter" class="dataTables_filter">
                        <label>
                          Search: <b-form-input v-model="searchRequest" type="text" debounce="500"></b-form-input>
                        </label>
                      </div>
                    </div>
                  </div>

                  <b-table :items="items" :fields="fields" :sticky-header="stickyHeader" :no-border-collapse="noCollapse"  :sort-direction="sortDirection" :sort-by.sync="sortBy" class="table-height"
                           :sort-desc.sync="sortDesc" responsive  table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline" hover :class="{'hide-scroll': isScrollHide()}">

                    <template v-slot:cell(action)="row">
                      <a class="btn btn-xs"  @click="detailRow(row.item, row.index, $event.target)" title="Detail" v-show="action_button.detail">
                        <em class="fa fa-search"></em>
                      </a>
                      <a class="btn btn-xs"  @click="editRow(row.item, row.index, $event.target)" title="Edit" v-if="row.item.comp_stat_id == 0 && action_button.edit">
                        <em class="fa fa-pencil-alt"></em>
                      </a>
                      <a class="btn btn-xs"  @click="deleteRow(row.item, row.index, $event.target)" title="Delete" v-if="row.item.comp_stat_id ===0 && action_button.delete">
                        <em class="fa fa-trash"></em>
                      </a>
                    </template>
                  </b-table>
                  <div class="row align-items-center">
                    <div class="col-sm-12 col-md-5">
                      <div class="dataTables_info" id="data-table-leave-request-request_info" role="status" aria-live="polite">Showing {{currentPage}} to {{perPage}} of {{rows}} entries</div>
                    </div>
                    <div class="col-sm-12 col-md-7 d-flex justify-content-end">
                      <div class="dataTables_paginate paging_simple_numbers">
                        <b-pagination v-model="currentPage" v-on:click="getData"  :per-page="perPage"  :total-rows="rows" ></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" :class="{ 'active show': isActive('compensatory-approval') }" >
                <div id="data-table-" class="dataTables_wrapper dt-bootstrap4 no-footer">
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div class="dataTables_filter"><label>Search:<input
                          type="search" class="form-control" placeholder=""
                          aria-controls="data-table-leave-request-request"></label></div>
                    </div>
                  </div>

                  <b-table :items="items" :fields="fields" :sticky-header="stickyHeader" :no-border-collapse="noCollapse"  :sort-direction="sortDirection" :sort-by.sync="sortBy" class="table-height"
                           :sort-desc.sync="sortDesc" responsive  table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline" hover :class="{'hide-scroll': isScrollHide()}">

                    <template v-slot:cell(action)="row">
                      <a class="btn btn-xs"  @click="detailRow(row.item, row.index, $event.target)" title="Detail" data-title="Detail" >
                        <em class="fa fa-search"></em>
                      </a>
                    </template>
                  </b-table>
                  <div class="row align-items-center">
                    <div class="col-sm-12 col-md-5">
                      <div class="dataTables_info" id="data-table-leave-approval-request_info" role="status" aria-live="polite">Showing {{currentPage}} to {{perPage}} of {{rows}} entries</div>
                    </div>
                    <div class="col-sm-12 col-md-7 d-flex justify-content-end">
                      <div class="dataTables_paginate paging_simple_numbers">
                        <b-pagination v-model="currentPage" v-on:click="getData"  :per-page="perPage"  :total-rows="rows" ></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.card-body -->
        </div>
        <compensatory-input :data="data" ref="mdl"></compensatory-input>
        <compensatory-detail :data="data" ref="mdl-det"></compensatory-detail>
        <b-modal id="modal-delete" hide-backdrop content-class="shadow" ref="modal-delete" title="Delete" @ok="deleteItem" @hide="resetModal" ok-title="Delete" ok-variant="danger">
          <p class="my-2">
            Are you sure delete this item ?
          </p>
        </b-modal>
      </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import {BTable, BPagination, BFormInput, VBToggle, VBModal, BModal} from "bootstrap-vue"
import CompensatoryInput from "@/components/pages/compensatory/CompensatoryInput";
import {mapGetters} from "vuex";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import CompensatoryDetail from "./CompensatoryDetail";
import Acl from "../../../../libs/AclButton";
export default {
  name: "Compensatory",
  components:{
    CompensatoryDetail,
    CompensatoryInput,
    BTable,
    Breadcrumb,
    BPagination,
    BFormInput,
    BModal
  },
  directives:{
    "b-toggle":VBToggle,
    "b-modal":VBModal
  },
  data(){
    return {
      activeItem:"compensatory-request",
      searchRequest:"",
      noCollapse:false,
      stickyHeader: true,
      sortDirection: 'asc',
      sortBy: '',
      sortDesc: false,
      items:[],
      fields: [
        { key: 'no', sortable: true , thStyle: {maxWidth: '60px', minWidth: '10px'}},
        { key: 'action', sortable: true, thStyle: {maxWidth: '150px', minWidth: '10px'} },
        { key: 'number',label:'Transaction Number', sortable: true },
        { key: 'date',label:'Overtime Date', sortable: true },
        { key: 'project', sortable: true },
        { key: 'reason', label:'Note',sortable: true },
        { key: 'comp_stat_name', label:'Status', sortable: true },
      ],
      currentPage:1,
      perPage:20,
      rows:0,
      data:null,
      filter:{
        transaction_number:"",
        period:"all",
        from_date:"",
        to_date:""
      },
      options_radio: [
        { text: 'All', value: 'all' },
        { text: 'Range', value: 'range' },
      ],
      config_date:{
        //wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        minDate:'today',
        locale: {
          rangeSeparator: ' - '
        },
      },
      showDate:false,
      title:"More",
      action_button:{
        add:false,
        edit:false,
        delete:false,
        detail:false
      }
    }
  },
  computed:{
    ...mapGetters([ 'scrollbarHide']),
  },
  watch:{
    currentPage(){
      this.getData()
    }
  },
  methods:{
    isScrollHide(){
      return this.scrollbarHide
    },
    setActive(itemTabs){
      this.activeItem = itemTabs
      this.getData()
    },
    isActive(itemTabs){
      return this.activeItem === itemTabs
    },
    getData(){
      this.items = []
      let payload = {
        emp_id:this.$store.getters.empId,
        page:this.currentPage,
        limit:this.perPage
      }

      if (this.activeItem === "compensatory-approval") payload.approval = true
      AxiosCall.Get(payload, urlApi.compensatory.index).then(res=>{
        if(res.success){
          let no = (this.currentPage - 1) * this.perPage + 1
          for (let data of res.atributes){
            data.no=no++
            data.project = data.project_abbreviation +' - '+data.var_name
            this.items.push(data)
          }
          this.rows = res.total
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    toInput(){
      this.$router.push({path:"compensatory-input"})
    },
    isShowDate(){
      this.showDate = true
      if (this.filter.period !== "all"){
        this.showDate =false
      }
    },
    isTitle(){
      this.title = (this.title === "More") ? "Less" :"More"
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    editRow(item){
      this.data = item
      this.$refs.mdl.$refs.modal.show()
    },
    detailRow(item){
      this.data = item
      this.$refs["mdl-det"].$refs.modal.show()
    },
    deleteRow(item){
      this.data = item
      this.$refs["modal-delete"].show()
    },
    deleteItem(){
      AxiosCall.Delete(urlApi.compensatory.delete+"/"+this.data.id).then(res=>{
        if (res.success){
          this.successMessage(res.message)
          this.getData()
          this.$refs["modal-delete"].hide()
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    resetModal(){
      this.data = null
    },
    checkAction(){
      for(let act in this.action_button){
        this.action_button[act] = Acl(this.$options.name, act)
      }
    }
  },
  mounted() {
    this.checkAction()
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      this.title = (isJustShown) ? "Less" :"More"
    })
    this.getData()
  }
}
</script>